<template>
  <div class="bodys">
    <navBar :s="transparency"></navBar>
    <a-carousel :after-change="onChange">
      <div class="banner-c">
        <div class="banner-text">
          <h1>我为群众办实事</h1>
        </div>
        <div class="banner">
          <img class="banner-img" src="../static/image/541617348155.jpg" alt="" />
        </div>
      </div>
      
    </a-carousel>
    <div class="section">
      <h2>惠民云服务</h2>
      <a-row :gutter="64">
        <a-col class="gutter-row" :span="8">
          <div class="gutter-box">
            <img
              class="gutter-box-img"
              src="../static/image/581617348766.jpg"
              alt=""
            />
            <div class="gutter-box-c">
              <h4>帮困电子卡使用告知</h4>
              <p>
                1.本粮油帮困电子卡采取实名制，无有效期，请妥善保管。首次领取粮油帮困电子卡的居民，须携带本人有效证件（身份证）前往所在街道社区事务受理服务中心领取（代领者需带好本人有效证件及持卡人有效证件）
              </p>
              <p>
                2.已持卡人员且符合粮油帮困条件的由系统于每季度第一个月月底前按帮困标准自动充值。
              </p>
              <p>
                3.持卡人凭粮油帮困电子卡可在本区内指定的粮油帮困供应点领取等值的粮油制品。
              </p>
            </div>
          </div>
        </a-col>
        <a-col class="gutter-row" :span="8">
          <div class="gutter-box">
            <img
              class="gutter-box-img"
              src="../static/image/591617348766.jpg"
              alt=""
            />
            <div class="gutter-box-c">
              <h4>商户服务</h4>
              <p>
                粮油帮困供应点商户，可使用本系统进行销售报表查询。如有疑问可联系客服人员。
              </p>
              <a-button class="login-btn" type="primary" ghost
                ><a :href="loginUrl" target="_blank">登录</a></a-button
              >
            </div>
          </div>
        </a-col>
        <a-col class="gutter-row" :span="8">
          <div class="gutter-box">
            <img
              class="gutter-box-img"
              src="../static/image/601617348769.jpg"
              alt=""
            />
            <div class="gutter-box-c">
              <h4>客服热线</h4>
              <span class="phonenum">400 629 8107</span>
              <div class="bg-c">
                如粮油帮困电子卡无法正常使用或丢失，持卡人可通过热线电话4006298107联系送修，或前往街道社区事务受理服务中心登记。因保管不当遗失，补卡费用由持卡人自行承担。
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="section">
      <h2>粮油帮困供应点查询</h2>
      <div>
        <div class="select-q">
          <a-select
            size="large"
            :default-value="provinceData[0].name"
            style="width: 150px"
            @change="(e)=>handleProvinceChange(e,provinceData)"
          >
            <a-select-option v-for="(province, index) in provinceData" :key="index">
              {{ province.name }}
            </a-select-option>
          </a-select>
          <a-select size="large" v-model="secondCity" style="width: 250px" @change="(value)=>handleProvinceChanges(value,cities[value])">
            <a-select-option v-for="(store, key) in cities" :key="key">
              {{ store.store_name }}
            </a-select-option>
          </a-select>
        </div>
        
        <baidu-map class="map" :center="center" :zoom="zoom" :scroll-wheel-zoom="true">
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <bm-point-collection v-if="points.length > 0" :points="points" shape="BMAP_POINT_SHAPE_STAR" color="red" size="BMAP_POINT_SIZE_BIG" @click="clickHandler"></bm-point-collection>
          <bm-marker :position="center" :dragging="false" @click="infoWindowOpen">
            <bm-info-window :show="show" :title="storeTitle" @close="infoWindowClose" :closeOnClick="false" @open="infoWindowOpen">
              <div>门店：{{shopName}}</div>
              <div>街道：{{street}}</div>
              <div>地址：{{address}}</div>
              <div>电话：{{tel}}</div>
            </bm-info-window>
          </bm-marker>
          <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"  :showAddressBar="true" :autoLocation="true"></bm-geolocation>
          <!-- <bm-view style="width: 100%; height: 100%; flex: 1" /> -->
        </baidu-map>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
// @ is an alias to /src
import navBar from "@/components/navBar.vue";
import footers from "@/components/footer.vue";
export default {
  components: {
    navBar,footers
  },
  data() {
    return {
      loginUrl: process.env.VUE_APP_LOGIN_URL,
      storeTitle: '<h2>门店信息</h2>',
      transparency: 0,
      provinceData: [
        {
          name: '全部',
          id: 0,
          second: [
            {store_name: "请选择", address: ''},
          ]
        }
      ],
      cities: [],
      secondCity: '请选择',
      center: {lng: 121.45, lat: 31.2},
      zoom: 14,
      show: false,
      points: [],
      shopName: '',
      street: '',
      address: '',
      tel: '',
    };
  },
  mounted() {
    this.getData()
    this.cities = this.provinceData[0].second;
    window.addEventListener('scroll', this.handleScroll)
    
  },
  updated() {
    
  },
  methods: {
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.transparency = scrollTop / 700;
    },
    getData() {
      this.$axios({
        method: 'get',
        url: process.env.VUE_APP_API + 'site/stores.html'
      }).then((response) =>{     //这里使用了ES6的语法
        if (response.data.errno == 0) {
          this.provinceData = response.data.data;
          // console.log(this.provinceData)
          var thisOne = {
            name: '全部',
            id: 0,
            second: [
              {store_name: "请选择", address: ''},
            ]
          }
          this.provinceData.unshift(thisOne);
          for (var i = 0;i < response.data.data.length;i++ ) {
            for (var j = 0;j<response.data.data[i].second.length;j++ ) {
              var item = {
                lng: response.data.data[i].second[j].lng,
                lat: response.data.data[i].second[j].lat
              }
              this.points.push(item);
            }
          }
          // console.log(this.points)
        }
      }).catch((error) => {
        console.log(error)       //请求失败返回的数据
      })
    },
    clickHandler (e) {
      this.show = false;
      for (var i = 0;i < this.provinceData.length;i++ ) {
        for (var j = 0;j<this.provinceData[i].second.length;j++ ) {
          if (e.point.lat == this.provinceData[i].second[j].lat) {
            this.zoom = 15;
            this.show = true;
            this.center = {
              lng: this.provinceData[i].second[j].lng,
              lat: this.provinceData[i].second[j].lat
            }
            this.shopName = this.provinceData[i].second[j].store_name;
            this.street = this.provinceData[i].second[j].street;
            this.address = this.provinceData[i].second[j].address;
            this.tel = this.provinceData[i].second[j].tel;
            console.log(this.show)
          }
        }
      }
    },
    infoWindowClose () {
      this.show = false
    },
    infoWindowOpen () {
      this.show = true
    },
    onChange(a, b, c) {
      console.log(a, b, c);
    },
    handleProvinceChange(e,province) {
      this.secondCity = "请选择";
      this.cities = this.provinceData[e].second;
      if (province[e].id == 0) {
        this.getData()
        this.center = '上海';
        this.zoom = 11;
      } else {
        this.center = province[e].name;
        this.zoom = 13;
        this.points = [];
        for (var i = 0;i < this.cities.length;i++ ) {
            var item = {
              lng: this.cities[i].lng,
              lat: this.cities[i].lat
            }
            this.points.push(item);
        }
      }
      
    },
    handleProvinceChanges(val,store) {
      this.show = true;
      this.center = {
        lng: store.lng,
        lat: store.lat
      }
      this.shopName = store.store_name;
      this.street = store.street;
      this.address = store.address;
      this.tel = store.tel;
    },
  },
};
</script>

<style scoped >
.bodys{
  padding-bottom: 1px;
}
/* For demo */
.ant-carousel >>> .slick-slide {
  text-align: center;
  /* height: 600px; */
  /* line-height: 160px; */
  /* background: #364d79; */
  overflow: hidden;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
.banner-c{
  position: relative;
}
.banner {
  width: 100%;
  min-width: 1600px;
  min-height: 500px;
}
.banner-text {
  position: absolute;
  z-index: 99;
  /* margin: 200px auto 0; */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 32px;
}
.banner-text > h1 {
  color: #fff;
  text-shadow: 5px 5px 5px #aaa;
  letter-spacing: 6px;
}
.banner-img {
  /* position: absolute; */
  /* z-index: 98; */
  /* top: 0; */
  /* left: 0; */
  width: 100%;
  min-width: 1600px;
  min-height: 500px;
}
.section {
  width: 1100px;
  margin: 50px auto;
}
.gutter-box {
  border: 1px solid #ddd;
  height: 400px;
}
.section > h2 {
  margin: 40px 0;
  font-size: 28px;
}
.gutter-box-img {
  width: 100%;
}
.gutter-box-c {
  padding: 15px;
  position: relative;
  height: 300px;
}
.gutter-box-c > h4 {
  font-size: 18px;
  text-align: left;
  margin-bottom: 15px;
}
.gutter-box-c > p {
  text-align: left;
}
.login-btn {
  /* position: absolute;
  bottom: 20px; */
  margin-top: 100px;
}
.phonenum {
  font-size: 36px;
}
.gutter-box-c > .bg-c {
  margin-top: 35px;
  /* position: absolute;
  bottom: 20px; */
  background-color: #eee;
  text-align: left;
  padding: 10px;
  color: #666;
  border-radius: 5px;
}
.map {
  width: 100%;
  height: 500px;
}
.select-q{
  margin-bottom: 20px;
}
.select-q .ant-select {
  /* background-color: #000; */
  margin: 0 0px;
  /* width: 150px !important; */
}
.select-q .ant-select-selection{
  /* background-color: #000; */
}
</style>